@if (articles.length) {
  <h3 class="mb-4 clickable">{{ "RECENTLY_VIEWED" | translate }}</h3>
  <div
    class="articleContainer row mb-3 px-0 d-flex"
    style="padding-left: 5px"
    [ngClass]="articles && articles.length ? 'hasArticles' : ''"
    >
    @for (article of articles; track article.id; let i = $index) {
      <app-article-card
        [article]="article"
        (showArticleDetails)="showArticleDetails(article)"
        [hideMatrix]="true"
        class="card d-flex align-items-stretch" [ngClass]="cardClass"
        >
      </app-article-card>
    }
  </div>
}
